export default class Tabs {
  constructor(tabBtn) {
    this.$ = tabBtn;
    this.wrapper = this.$.closest('.js-tabs');
    this.btns = Array.from(this.wrapper.querySelectorAll('.js-tabs-btn'));
    this.contents = Array.from(this.wrapper.querySelectorAll('.js-tabs-cont'));
    this.condition = this.wrapper.getAttribute('data-showed');
    this.currentClass = 'm-current';
    this.hiddenClass = 'm-hidden';
    this.tabHiddenClass = 'current';
    this.initialize();
    this.bind();
  }

  initialize() {
    this.btns.forEach(btn => {
      const thisVal = btn.getAttribute('value');
      btn.classList.remove(this.currentClass);
      if(thisVal == this.condition){
        btn.classList.add(this.currentClass);
      }
      const thisCont = this.wrapper.querySelector(thisVal);
      // console.log('thisCont',thisCont);
      thisCont.classList.add(this.hiddenClass);
      thisCont.classList.remove(this.tabHiddenClass);
      thisCont.style.position = 'absolute';
      thisCont.style.zIndex = '-1';

      const showCont = this.wrapper.querySelector(this.condition);
      showCont.style.position = 'relative';
      showCont.style.zIndex = '1';
      showCont.classList.remove(this.hiddenClass);
    });
  }

  bind() {
    this.$.addEventListener('click', this.tabSwitch.bind(this));
  }

  tabSwitch() {
    this.wrapper.dataset.showed = this.$.getAttribute('value');
    this.btns.forEach(btn => {
      btn.classList.remove(this.currentClass);
      if(btn.getAttribute('value') == this.$.getAttribute('value')){
        btn.classList.add(this.currentClass);
      }
    });
    this.contents.forEach(cont => {
      if(this.$.getAttribute('value').replace('#','') != cont.getAttribute('id')){
        cont.classList.add(this.hiddenClass);
        cont.classList.remove(this.tabHiddenClass);
        cont.style.position = 'absolute';
        cont.style.zIndex = '-1';
      }else{
        cont.style.position = 'relative';
        cont.style.zIndex = '1';
        cont.classList.remove(this.hiddenClass);
      }
    });

  }

}

